'use client';
import Link from 'next/link';
import { useMemo } from 'react';
import './card.scss';

export type CardProps = {
    title: number;
    minPrice?: string;
    maxPrice?: string;
    href: string;
    type: 'carros' | 'motos';
};

const Card = ({ title, minPrice, maxPrice, href, type }: Readonly<CardProps>) => {
    const subtitle = useMemo(() => {
        if (type === 'motos') return '';
        if (!minPrice || !maxPrice) return 'Preços não disponíveis';
        else return `Preços de ${minPrice} a ${maxPrice}`;
    }, [type, minPrice, maxPrice]);

    return (
        <Link href={href} className={`card card--${type}`} data-testid="card-link" id={`card-link-${type}`}>
            <h3 className="card-title" data-testid="card-title" id={`card-title-${type}`}>{title}</h3>
            <h3 className="card-subtitle" data-testid="card-subtitle" id={`card-subtitle-${type}`}>{subtitle}</h3>
        </Link>
    );
};

export default Card;
